<template>
  <div id="category-type-tab">
    <div class="at-tab-left-container">
      <div
        v-for="(cat, idx) in leftCategory"
        :key="idx"
        :class="[
          leftActiveTab === cat.value ? 'active' : '',
          loading ? 'loading' : '',
          'at-tab',
        ]"
        @click="leftToggle(cat.value)"
      >
        <span
          v-if="!cat.hide"
          class="at-label"
        >{{ cat.label }}</span>
        <span
          v-if="!loading && cat.count && !cat.hide"
          class="at-count"
        >
          {{ cat.count }}
        </span>
      </div>
    </div>
    <div class="at-tab-right-container">
      <div
        v-for="(cat, idx) in rightCategory"
        :key="idx"
        :class="[
          rightActiveTab === cat.value ? 'active' : '',
          loading ? 'loading' : '',
          cat.className ? cat.className : '',
          'atr-tab',
        ]"
        @click="rightToggle(cat.value)"
      >
        <span class="atr-label">{{ cat.label }}</span>
        <span
          v-if="!loading"
          class="atr-count"
        >
          {{ cat.count }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CategoryTab',
  props: {
    loading: Boolean,
    leftActiveTab: String,
    rightActiveTab: String,
    leftCategory: Array,
    rightCategory: Array,
    leftToggle: Function,
    rightToggle: Function,
  },
  methods: {
    handleFilter(filter, value) {
      if (value) {
        this.$store.dispatch('changeCustomerProfileTab', {
          activeTab: this.activeProfileTab,
          filter,
        });
      } else {
        this.$store.dispatch('changeCustomerProfileTab', {
          activeTab: this.activeProfileTab,
        });
      }
      this[filter] = value;
    },
  },
};
</script>

<style lang="scss">

#category-type-tab {
  display: flex;
  justify-content: space-between;
  height: 52px;
  padding: 0 16px;
  .at-tab-left-container {
    display: flex;
    align-items: center;
  }
  .at-tab-right-container {
    display: flex;
    align-items: center;
  }
  .at-tab-checkbox {
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    color: $BLACK;
    font-size: 1.0rem;
    font-weight: 500;
    height: 36px;
  }
  .at-tab {
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    color: $BLACK;
    font-size: 1.125rem;
    font-weight: 500;
    height: 56px;
    .at-count {
      margin-left: 8px;
      background-color: $N100;
      color: $WHITE;
      font-size: 0.875rem;
      height: 20px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      padding: 3px 11px 3px 12px;
    }
    &:not(.loading) {
      &:hover {
        background-color: $NBLUE10;
      }
      &.active {
        color: $NBLUE100;
        background-color: $NBLUE10;
        .at-label {
          margin-bottom: -3px;
        }
        .at-count {
          margin-bottom: -3px;
        }
      }
    }
  }
  .atr-tab {
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    color: $BLACK;
    font-size: 1.125rem;
    font-weight: 500;
    height: 56px;
    &.red-info {
      color: $TOMATO100;
      .atr-count {
        background-color: $TOMATO100;
      }
    }
    &.yellow-info {
      color: $SUNSET100;
      .atr-count {
        background-color: $SUNSET100;
      }
    }
    &.green-info {
      color: $BASIL100;
      .atr-count {
        background-color: $BASIL100;
      }
    }
    .atr-count {
      margin-left: 8px;
      background-color: $N100;
      color: $WHITE;
      font-size: 0.875rem;
      height: 20px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      padding: 3px 11px 3px 12px;
    }
    &:not(.loading) {
      &:hover {
        background-color: $NBLUE10;
      }
      &.active {
        border-bottom: 3px $NBLUE100 solid;
        background-color: $NBLUE10;
        .atr-label {
          margin-bottom: -3px;
        }
        .atr-count {
          margin-bottom: -3px;
        }
      }
    }
  }
}
</style>
